import { c as _c } from "react/compiler-runtime";
export default function MetricsError(t0) {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <div className="tw-rounded-xl tw-border tw-border-red/30 tw-bg-red/10 tw-p-6 tw-text-center"><p className="tw-text-red">{message}</p></div>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}